import { createFileRoute } from '@tanstack/react-router';
import { buildHead } from '../../../../utils/seo';

export const Route = createFileRoute('/_layout/products/automation-review/')({
  head: () => buildHead('/products/automation-review'),
});

